import { Button, HStack } from '@chakra-ui/react';

interface ButtonOptions {
  /** The label of the button */
  label: string;
  /** The onClick function of the button */
  onClick: () => void;
  /** Whether the button is selected */
  isSelected: boolean;
}

interface SegmentedButtonControlProps {
  /** Whether the button is disabled @default false */
  isDisabled?: boolean;
  /** The left button options */
  leftButton: ButtonOptions;
  /** The right button options */
  rightButton: ButtonOptions;
}

export default function SegmentedButtonControl({
  isDisabled = false,
  leftButton,
  rightButton,
}: SegmentedButtonControlProps) {
  return (
    <HStack spacing={0} backgroundColor="neutral.50" borderRadius="8px">
      <Button
        isDisabled={isDisabled}
        flex={1}
        onClick={leftButton.onClick}
        backgroundColor={leftButton.isSelected ? 'neutral.100' : 'transparent'}
        color="neutral.1200"
        borderRadius="8px"
        _hover={{
          backgroundColor: 'neutral.100',
          color: 'neutral.1200',
        }}
      >
        {leftButton.label}
      </Button>

      <Button
        isDisabled={isDisabled}
        flex={1}
        onClick={rightButton.onClick}
        borderRadius="8px"
        backgroundColor={rightButton.isSelected ? '#3DC178' : 'transparent'}
        color={rightButton.isSelected ? 'white' : 'neutral.1200'}
        _hover={{
          backgroundColor: '#3DC178',
          color: 'white',
        }}
      >
        {rightButton.label}
      </Button>
    </HStack>
  );
}
